module.exports = __webpack_public_path__ + "static/media/dollar-sign-solid.63fa626f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dollar-sign-solid.svg
// module id = 233
// module chunks = 0